
<template>
  <div>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          style="float:right"
          @click="handleAddGroup"
        >
          新增
          <i class="el-icon-plus el-icon--right" />
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          :data="tableDataGroup"
          style="width: 100%"
          :show-header="false"
          @row-click="handleRowClick"
        >
          <el-table-column
            prop="groupName"
          />
          <el-table-column
            fixed="right"
            align="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="handleEditGroup(scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="small"
                @click.native.prevent="handleCloseGroup(scope.row)"
              >
                关闭
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <GroupEdit
      v-model="groupEditShow"
      :group-type="groupType"
      :entity-id="groupEntityId"
      @save-success="handleSearch"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import LoadingOptions from '@/components/commonSetting'
import GroupEdit from './groupEdit'
export default {
  components: {
    GroupEdit
  },
  props: {
    groupType: { type: String, default: '' }
  },
  data() {
    return {
      title: '项目组',
      groupEditShow: false,
      groupEntityId: null,
      tableDataGroup: []
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  activated() {
    this.handleSearch()
  },
  methods: {
    // 查询
    handleSearch() {
      pathReq.getForm('/api/services/app/td03/GetPagedListtd03s', {
        GroupType: this.groupType
      }).then((resp) => {
        this.tableDataGroup = resp.data.result.items
      })
    },
    // 新增组
    handleAddGroup() {
      this.groupEntityId = null
      this.groupEditShow = true
    },
    // 修改组
    handleEditGroup(row) {
      this.groupEntityId = row.id
      this.groupEditShow = true
    },
    // 关闭组
    handleCloseGroup(row) {
      const that = this
      this.$confirm('确定要关闭该项目组吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading(LoadingOptions.loadOptions)
        const path = '/api/services/app/td03/Closetd03'
        pathReq
          .postForm(path, {
            id: row.id
          })
          .then(res => {
            if (res.status === 200) {
              if (res.data.success) {
                this.$message.success('关闭项目组成功！')
                that.handleSearch()
              } else {
                this.$message.error('关闭项目组失败！')
              }
            }
            loading.close()
          })
      })
    },
    // 点击组
    handleRowClick(row) {
      this.$bus.$emit('td03/search01', row.id)
    }

  }
}
</script>

